import { memo, ReactNode } from 'react'
import { Box, Toolbar } from '@mui/material'

import Footer from './components/Footer/footer'
import Header from './components/Header/header'
import './style.css'

type LayoutProps = {
  children: ReactNode
}

function Layout({ children }: LayoutProps) {
  return (
    <Box sx={{ display: 'flex', height: '100vh', flexDirection: 'column', scrollbarWidth: 'none' }}>
      <Header />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
        }}
      >
        <Toolbar />
        <Box
          sx={{
            height: '100%',
            display: 'flex',
            alignItems: 'start',
            overflow: 'hidden',
          }}
        >
          <Box
            sx={{
              height: '100%',
              marginTop: '17px',
              width: '100%',
            }}
          >
            {children}
          </Box>
        </Box>
      </Box>
      <Footer />
    </Box>
  )
}

export default memo(Layout)
